module.exports = __webpack_public_path__ + "img/meteoblue.c4b617d9.png";